import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@hires/player-ui/styles.css";

import "./app.css";
import { supportViewFromSearch } from "./support-content";

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("The application root element is missing.");
}
const root = createRoot(rootElement);
const supportView = supportViewFromSearch(window.location.search);

if (supportView) {
    void import("./support-viewer").then(({ SupportViewer }) => {
        root.render(
            <StrictMode>
                <SupportViewer view={supportView} />
            </StrictMode>,
        );
    });
}
else {
    void Promise.all([import("./app"), import("./runtime-logger")]).then(([{ App }, runtimeLogger]) => {
        runtimeLogger.logBrowserStartup();
        runtimeLogger.startBrowserMemoryLogging();
        root.render(
            <StrictMode>
                <App />
            </StrictMode>,
        );
    });
}
